import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { DATES } from './dates';
import { capitalizeFirstLetter } from './general.util';
const getCurrentDate = () => {
	const date = new Date();
	return {
		year: date.getFullYear(),
		month: date.getMonth() + 1,
		day: date.getDate(),
	};
};

const getPrefixMonth = (month: number) => {
	switch (month) {
		case 1:
			return 'Ene';
		case 2:
			return 'Feb';
		case 3:
			return 'Mar';
		case 4:
			return 'Abr';
		case 5:
			return 'May';
		case 6:
			return 'Jun';
		case 7:
			return 'Jul';
		case 8:
			return 'Ago';
		case 9:
			return 'Sep';
		case 10:
			return 'Oct';
		case 11:
			return 'Nov';
		case 12:
			return 'Dic';

		default:
			return '';
	}
};

const getFormatDate = (
	date: string,
	format: string = 'DD MMM YYYY',
	custom?: boolean,
	capitalize?: boolean,
) => {
	let dateToFormat = date;
	if (date?.includes('T00:00:00.000Z')) {
		dateToFormat = date?.split('T')?.[0] + 'T10:00:00.000Z';
	}

	if (custom) {
		return `${dayjs(dateToFormat)?.locale('es')?.format('DD')} de ${dayjs(
			dateToFormat,
		)
			?.locale('es')
			?.format(
				'MMMM',
			)} de ${dayjs(dateToFormat)?.locale('es')?.format('YYYY')}`;
	}
	if (capitalize) {
		const formattedDate = dayjs(dateToFormat).locale('es');
		const day = formattedDate?.format('DD');
		const month = capitalizeFirstLetter(formattedDate?.format('MMMM'));
		const year = formattedDate?.format('YYYY');

		return `${day} ${month} ${year}`;
	}
	return dayjs(dateToFormat)?.locale('es')?.format(format);
};

const getMonthName = (month: number, capitalize?: boolean) => {
	if (!month) return "";
	const monthName = dayjs()
		.month(month - 1)
		.locale('es')
		.format('MMMM');

	return capitalize ? capitalizeFirstLetter(monthName) : monthName;
};

const getYearByPeriod = () => {
	const currentDate = dayjs();
	const mayFirst = dayjs(`${DATES.currentYear}-06-01`);

	if (currentDate.isBefore(mayFirst)) {
		return mayFirst.year() - 1;
	} else {
		return DATES.currentYear;
	}
};

/**
 * Obtiene el mes en curso (mes actual del calendario)
 * Para verificar si una declaración corresponde al mes que está transcurriendo
 * Ej: En noviembre 2025, retorna noviembre 2025
 */
const getCurrentFilingPeriod = () => {
	const current = getCurrentDate();
	return { month: current.month, year: current.year };
};

/**
 * Verifica si una declaración corresponde al mes en curso (mes actual)
 */
const isCurrentFilingPeriod = (declarationMonth: number, declarationYear: number) => {
	const currentPeriod = getCurrentFilingPeriod();
	return declarationMonth === currentPeriod.month && declarationYear === currentPeriod.year;
};

export {
	getCurrentDate,
	getPrefixMonth,
	getFormatDate,
	getMonthName,
	getYearByPeriod,
	getCurrentFilingPeriod,
	isCurrentFilingPeriod,
};
